import { render, staticRenderFns } from "./MonitorView.vue?vue&type=template&id=4a0e50b6&scoped=true"
import script from "./MonitorView.vue?vue&type=script&lang=js"
export * from "./MonitorView.vue?vue&type=script&lang=js"
import style0 from "./MonitorView.vue?vue&type=style&index=0&id=4a0e50b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e50b6",
  null
  
)

export default component.exports